module.exports = __webpack_public_path__ + "img/LogoBigO_Software_500x180.d40835fc.svg";